import React from 'react';

const Missing = () => {
  return <div>Route is missing</div>;
};

export default Missing;
